import { useQuery } from "react-query";
import { developAxios } from "../../axios.config";
import { useMemo } from "react";

interface UnSubmittedUsersResponse {
	unsubmittedUsers: Array<{
		user: {
			firstName: string;
			email: string;
		};
		_id: string;
		status: "unsubmitted";
	}>;
	isLoading: boolean;
}

type apiResponse = Array<{
	email: string;
	firstName: string;
	_id: string;
}>;

function useUnsubmittedUsers(
	_id: string,
	type: "quiz" | "coding"
): UnSubmittedUsersResponse {
	const { data, isLoading } = useQuery(
		["getUnsubmittedUsers", _id, type],
		() => {
			if (type === "coding") {
				return developAxios(
					localStorage.getItem("token") || ""
				).get<apiResponse>(`/getUnsubmittedUsers/${_id}`);
			} else {
				return developAxios(
					localStorage.getItem("token") || ""
				).get<apiResponse>(`/getUnSubmittedUsersByExamId_quiz/${_id}`);
			}
		},
		{
			refetchInterval: 20000,
		}
	);

	const unsubmittedUsers = useMemo<
		Array<{
			user: {
				firstName: string;
				email: string;
			};
			_id: string;
			status: "unsubmitted";
		}>
	>(() => {
		if (!data) return [];

		return data.data.map(
			(val: { email: string; firstName: string; _id: string }) => ({
				user: {
					firstName: val.firstName,
					email: val.email,
				},
				_id: val._id,
				status: "unsubmitted",
			})
		);
	}, [data]);

	return { unsubmittedUsers, isLoading };
}

export default useUnsubmittedUsers;
